import React from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap";

const LanguageSwitcher = () => {
	const { i18n } = useTranslation();

	const languages = [
		{ code: "en", name: "English Only", flag: "🇬🇧" },
		{ code: "ta", name: "English + தமிழ்", flag: "🇬🇧🇮🇳" },
	];

	const currentLanguage =
		languages.find((lang) => lang.code === i18n.language) || languages[1];
	const changeLanguage = (langCode) => {
		i18n.changeLanguage(langCode);
		localStorage.setItem("language", langCode);
	};

	return (
		<Dropdown as="div" className="nav-item dropdown notification_dropdown">
			<Dropdown.Toggle variant="" className="nav-link i-false p-0" as="div">
				<div className="d-flex align-items-center px-3">
					<div className="text-start d-none d-md-block">
						<small className="d-block text-muted" style={{ fontSize: "10px" }}>
							{currentLanguage.flag}
						</small>
						<strong style={{ fontSize: "12px" }}>
							{currentLanguage.name}
						</strong>
					</div>
					<i className="fa fa-angle-down ms-2"></i>
				</div>
			</Dropdown.Toggle>
			<Dropdown.Menu align="end" className="dropdown-menu-end">
				{languages.map((lang) => (
					<Dropdown.Item
						key={lang.code}
						onClick={() => changeLanguage(lang.code)}
						active={lang.code === i18n.language}
					>
						<span className="me-2">{lang.flag}</span>
						{lang.name}
					</Dropdown.Item>
				))}
			</Dropdown.Menu>
		</Dropdown>
	);
};

export default LanguageSwitcher;
